import React from 'react'
import { getReportName, getStateLoaded, getReportData, setReportDoc, setReportTexts } from 'store/store';
import { getAttrValue, getEleArray } from 'helpers/Helpers';

export function loadReport() {

	const xmlData = getReportData();
	const convert = require('xml-js');

	const reportData = convert.xml2json(xmlData, {
		compact: true,
		spaces: 2
	});

	var reportDoc = JSON.parse(reportData);
	setReportDoc(reportDoc);
	///console.log("reportDoc: ",typeof reportDoc, reportDoc);

	var cr = reportDoc.RESPONSE_GROUP.RESPONSE.RESPONSE_DATA.CREDIT_RESPONSE;
	// console.log("cr: ", typeof cr, cr);

	// collect text reports

	var textFiles = [];
	var embed = getEleArray(cr,"EMBEDDED_FILE");
	//console.log("embed: ", embed);
	embed.forEach((e) => {
		//console.log("e: ", e);
		var ext = getAttrValue(e, "_Extension");
		var doc = e.DOCUMENT._cdata;
		doc = doc.slice(9, -2);
		var file = {
			Repository: ext,
			Document: doc
		}
		//console.log("doc: ", doc);
		textFiles.push(file);
	});

	console.log("textFiles: ", textFiles);
	setReportTexts(textFiles);

}
